import CreatePage from './CreatePage.container';
import EditPage from './EditPage.container';
import ListPage from './ListPage';
import ViewInvitedUsers from './ViewInvitedUsers';

export default { ListPage, CreatePage, EditPage, ViewInvitedUsers };
